import { Flex, Text } from "@radix-ui/themes";
import { TitleBlock } from "../routes/TitleBlock";

/**
 * Success content shown once a brand-new account finishes phone verification
 * from the waitlist flow. Rendered inside the waitlist modal (see
 * WaitlistModal) rather than on its own route: it explains that Iris will
 * reach out directly when capacity is available instead of sending the user
 * straight into the product.
 */
export function WaitlistConfirmation() {
  return (
    <Flex direction="column" gap="4" align="center">
      <TitleBlock
        title="You're on the Waitlist!"
        subtitle="Iris will reach out directly when capacity is available."
        innerStyle={{
          minHeight: "auto",
          padding: "40px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        headingStyle={{
          fontSize: 27,
          fontWeight: 400,
          lineHeight: "30px",
        }}
      />
      <Text align="center" size="2" color="gray">
        Have questions? Contact our friendly support team at
        support@chatwithiris.com
      </Text>
    </Flex>
  );
}
